var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"ActTwelveFloat",class:{ 'ON': _vm.isShow && _vm.uniq_id != 'P75968134'  },attrs:{"href":_vm.PAY_COMPANY_NEW,"target":"_blank"}},[_c('i',{staticClass:"icon_close2",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.isShow = false}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }